import { UserEntityPreferredLanguage } from "@/api/__generated__/orval/auth";

const mappingComplexLocales: Partial<
  Record<NonNullable<UserEntityPreferredLanguage>, string>
> = {
  [UserEntityPreferredLanguage.jp]: "ja",
};

type GetUserLocaleProps = {
  locale?: UserEntityPreferredLanguage;
};

/**
 * Function to get the locale from the user's language
 * @param locale - The language of the user
 * @returns The locale of the user
 */
export const getUserLocale = ({ locale }: GetUserLocaleProps) => {
  const resolvedLocale = locale ?? UserEntityPreferredLanguage.en;

  if (mappingComplexLocales[resolvedLocale]) {
    return mappingComplexLocales[resolvedLocale];
  }

  return resolvedLocale;
};
